module.exports = __webpack_public_path__ + "static/img/zs1.7d9fad64.png";